import { render } from "./SentimentComparison.vue?vue&type=template&id=0d61a427"
import script from "./SentimentComparison.vue?vue&type=script&lang=js"
export * from "./SentimentComparison.vue?vue&type=script&lang=js"

import "./SentimentComparison.vue?vue&type=style&index=0&id=0d61a427&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__